import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BarreNavigation from "../../components/BarreNavigation/BarreNavigation";
import Navbarhorizontal from "../../components/Navbarhorizontal/Navbarhorizontal";
import { toast } from "react-toastify";
import API_BASE_URL from "../../API/ConfigAPI";
import UserForm from "../../components/UserForm/UserForm";
import "./userslist.css";
function UsersList() {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState({
    id: null,
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    is_admin: false,
    password: "",
    societes: [],
  });
  const [error, setError] = useState("");
  const [availableSocietes, setAvailableSocietes] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMode, setModalMode] = useState("add"); // 'add' ou 'edit'
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [userIdToDelete, setUserIdToDelete] = useState(null);



const fetchUsers = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${API_BASE_URL}/home/api/users/`, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Erreur lors de la récupération des utilisateurs.");
    }

    const data = await response.json();
    setUsers(data);
  } catch (error) {
    console.error("Erreur lors de la récupération des utilisateurs:", error);
  }
};

  useEffect(() => {
    fetchUsers();
  }, []); // Les crochets vides indiquent que cet effet ne dépend d'aucune variable d'état et ne s'exécute qu'une fois après le premier rendu

  // Créer une liste unique de toutes les sociétés

  useEffect(() => {
    if (isModalOpen) {
      // Ajoute la classe pour désactiver le défilement
      document.body.classList.add("body-no-scroll");
    } else {
      // Retire la classe pour réactiver le défilement
      document.body.classList.remove("body-no-scroll");
    }

    return () => {
      // Nettoie lorsque le composant est démonté
      document.body.classList.remove("body-no-scroll");
    };
  }, [isModalOpen]);


  useEffect(() => {
    const token = localStorage.getItem("token");
  
    const fetchAvailableSocietes = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/home/api/societes/?gestionnaire_vide=true`, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des sociétés");
        }
  
        const data = await response.json();
        setAvailableSocietes(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des sociétés:", error);
      }
    };
  
    fetchAvailableSocietes();
  }, []);
  

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentUser({
      ...currentUser,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const token = localStorage.getItem("token");
    if (!token) {
      setError("Vous n'êtes pas connecté.");
      return;
    }
  
    const userData = {
      username: currentUser.username,
      email: currentUser.email,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      is_admin: currentUser.is_admin,
      ...(modalMode === "add" && { password: currentUser.password }),
    };
  
    try {
      const url = currentUser.id
        ? `${API_BASE_URL}/home/api/users/${currentUser.id}/`
        : `${API_BASE_URL}/home/api/users/`;
  
      const method = currentUser.id ? "PUT" : "POST";
  
      const response = await fetch(url, {
        method: method,
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        if (data && typeof data === "object") {
          Object.keys(data).forEach((key) => {
            const errorMessage = data[key];
            if (Array.isArray(errorMessage)) {
              errorMessage.forEach((message) => {
                toast.error(`${key}: ${message}`);
              });
            } else {
              toast.error(`${key}: ${errorMessage}`);
            }
          });
        } else {
          toast.error("Une erreur s'est produite lors de la mise à jour des données.");
        }
        return;
      }
  
      // ✅ Si édition et sociétés associées :
      if (currentUser.id && modalMode === "edit" && currentUser.societes.length) {
        await fetch(`${API_BASE_URL}/home/api/societes/reset/${currentUser.id}/`, {
          method: "POST",
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        });
  
        await Promise.all(
          currentUser.societes.map((societe) =>
            fetch(`${API_BASE_URL}/home/api/societes/${societe.id}/`, {
              method: "PUT",
              headers: {
                Authorization: `Token ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                gestionnaire: currentUser.id,
                siret: societe.siret,
                nom: societe.nom,
              }),
            })
          )
        );
      }
  
      toast.success("Utilisateur mis à jour avec succès !");
    } catch (error) {
      console.error("Erreur lors de la sauvegarde :", error);
      toast.error("Une erreur s'est produite lors de la mise à jour.");
    } finally {
      setTimeout(() => {
        closeModal();
      }, 100);
  
      fetchUsers(); // ⚡ Recharger les utilisateurs
      setCurrentUser({
        id: null,
        username: "",
        email: "",
        first_name: "",
        last_name: "",
        is_admin: false,
        password: "",
        societes: [],
      });
    }
  };
  
  const openModal = (user = null) => {
    const mode = user ? "edit" : "add";
    setModalMode(mode);
    setIsModalOpen(true);

    if (user) {
      setCurrentUser({ ...user, password: "" }); // Mode édition
    } else {
      // 🔥 Vider TOUS les champs, même s'il y a du localStorage
      setCurrentUser({
        id: null,
        username: "",
        email: "",
        first_name: "",
        last_name: "",
        is_admin: false,
        password: "",
        societes: [],
      });
    }

    setModalTitle(user ? "Modifier un utilisateur" : "Ajouter un utilisateur");
  };

 
  const handleDelete = (userId) => {
    setUserIdToDelete(userId);
    setShowDeleteModal(true);
  };
  const confirmDeleteUser = async () => {
    const token = localStorage.getItem("token");
  
    try {
      const response = await fetch(`${API_BASE_URL}/home/api/users/${userIdToDelete}/`, {
        method: "DELETE",
        headers: {
          Authorization: `Token ${token}`,
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.detail || "Erreur lors de la suppression de l’utilisateur.";
        throw new Error(errorMessage);
      }
  
      toast.success("Utilisateur supprimé avec succès !");
      setUsers((prev) => prev.filter((user) => user.id !== userIdToDelete));
    } catch (error) {
      toast.error(error.message);
      console.error("Erreur lors de la suppression de l’utilisateur:", error);
    } finally {
      setShowDeleteModal(false); // Fermer la modale dans tous les cas
      setUserIdToDelete(null);
    }
  };
  
  

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="parent-layout-usres">
      <BarreNavigation />
      <div className="content">
        <Navbarhorizontal />

        <div className="container">
          <h1>Gestion des habilitations</h1>
          <button className="btn-ajout" onClick={() => openModal()}>
            Ajouter un utilisateur
          </button>

          <div className="table-container">
            <table className="users_table">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Prénom</th>
                  <th>Nom de famille</th>
                  <th>Adresse Email</th>
                  <th>Admin</th>
                  {/* <th>Sociétés</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.username}</td>
                    <td>{user.first_name}</td>
                    <td>{user.last_name}</td>
                    <td>{user.email}</td>
                    <td>{user.is_admin ? "Oui" : "Non"}</td>
                    {/* <td className="societes-cell" >
                        {user.societes?.map((societe, index) => (
                          <span key={index}>
                            {" "}
                            * {societe.nom} - siret {societe.siret} <br />
                          </span>
                        ))}
                      </td> */}
                    <td>
                      <div className="btn-container">
                        <button
                          className="edit-btn"
                          onClick={() => openModal(user)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(user.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {isModalOpen && (
            <Modal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              title={modalTitle}
            >
              <div className="modal-body">
              <UserForm 
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              modalMode={modalMode}
              closeModal={closeModal}
              error={error}
              availableSocietes={availableSocietes}
            />
              </div>
            </Modal>
          )}
        </div>
      </div>
      <Modal
  isOpen={showDeleteModal}
  onClose={() => setShowDeleteModal(false)}
  title="Confirmation de suppression"
>
  <div className="modal-body">
    <p>Êtes-vous sûr de vouloir supprimer cet utilisateur ?</p>
    <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1rem" }}>
      <button className="cancel-button" onClick={() => setShowDeleteModal(false)}>Annuler</button>
      <button className="submit-button" onClick={confirmDeleteUser}>Supprimer</button>
    </div>
  </div>
</Modal>

    </div>

    
  );
}

export default UsersList;
